function cta(data) {
    if (!data) {
        const markup = `<div class="card__cta">
        <span class="card__cta-icon">
            <svg width="6" height="14">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#chevron-right"></use>
            </svg>
        </span>
        <p class="card__cta-text">Discover more</p>
    </div>`

        return markup
    } else {
        return ''
    }
}

const template = (data) => `
    <div class="grid__item">
        <article class="card card--with-logo card--hover-shadow-only ${data.accent}">
            ${data.noLink ? '' : `<a href="${data.url}" class="card__link" target="${data.target}"><div class="card__shape"></div>`}
                <div class="card__container">
                    <div>
                        <div class="card__logo">
                            ${data.image?.src ? `<img src="${data.image?.src}" alt="${data.image?.alt}"  />` : ''}
                        </div>
                        ${data.title ? `<h3 class="card__heading sr-only">${data.title}</h3>` : ''}
                        <p class="card__description">${data.content}</p>
                    </div>
                    ${cta(data.noLink)}
                </div>
            ${data.noLink ? '' : '</a>'}
        </article>
    </div>
`
export default template
